import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Constants - Functions
import { pathHomePage } from "../../../../../config/constants";
// Components
import { MainContainer, BackLink, ArrowImg, LinkText, PreviousAndNextDiv, NavigationButton, SeparatorDiv } from "./styles";
// Assets
import ArrowBackImg from "../../../../../assets/icons/ico_arrow_back.svg";
import ArrowLeftImg from "../../../../../assets/icons/ico_arrow_left_bold.svg";
import ArrowRightImg from "../../../../../assets/icons/ico_arrow_right_bold.svg";

const SessionNavigation = ({ numberOfSessions }) => {
  const { clinicianToken, patientId, sessionNumber } = useParams();
  const [t] = useTranslation("global");

  const updateSessionNumberLink = (newSessionNumber) => {
    window.location.href = `${pathHomePage}/sessions/icu/${clinicianToken}/${patientId}/${newSessionNumber}`;
  };

  const redirectPreviousSession = () => {
    let newSessionNumber;
    if (Number(sessionNumber) === 1) {
      newSessionNumber = numberOfSessions;
    } else {
      newSessionNumber = Number(sessionNumber) - 1;
    }
    updateSessionNumberLink(newSessionNumber);
  };

  const redirectNextSession = () => {
    let newSessionNumber;
    if (numberOfSessions === Number(sessionNumber)) {
      newSessionNumber = 1;
    } else {
      newSessionNumber = Number(sessionNumber) + 1;
    }
    updateSessionNumberLink(newSessionNumber);
  };

  const renderBackLink = () => {
    return (
      <BackLink to={`${pathHomePage}/prescriptions/icu/${clinicianToken}/${patientId}`}>
        <ArrowImg src={ArrowBackImg} alt="ico-arrow-back" margin="0 10px 0 0" margin960="0 5px 0 0" />
        <LinkText>{t("rgsicu_sessionsList")}</LinkText>
      </BackLink>
    );
  };

  return (
    <MainContainer>
      {renderBackLink()}
      <PreviousAndNextDiv>
        <NavigationButton onClick={redirectPreviousSession}>
          <ArrowImg src={ArrowLeftImg} alt="ico-arrow-left" margin="0 10px 0 0" margin960="0 5px 0 0" />
          <LinkText>{t("previous")}</LinkText>
        </NavigationButton>
        <SeparatorDiv />
        <NavigationButton onClick={redirectNextSession}>
          <LinkText>{t("next")}</LinkText>
          <ArrowImg src={ArrowRightImg} alt="ico-arrow-right" margin="0 0 0 10px" margin960="0 0 0 5px" />
        </NavigationButton>
      </PreviousAndNextDiv>
    </MainContainer>
  );
};

export default SessionNavigation;
